import React, {  useState } from 'react';
import { useStripe, useElements, PaymentElement } from '@stripe/react-stripe-js';
import { StyledButton, LoadText } from 'pages/membership/MemberCardPay.style'

const SetupIntent = ({cardId,userName,closePayPopupHandle}) => {
  const url = window.location.origin;
  const stripe = useStripe();
  const elements = useElements();
  const [errorMessage, setErrorMessage] = useState(null);
  const [payLoading, setPayLoading] = useState(false);
  const [clickSumbit, setClickSumbit] = useState(false);

  const handleSubmit = async (event) => {
      // We don't want to let default form submission happen here,
      // which would refresh the page.
      event.preventDefault();

      if (!stripe || !elements) {
          // Stripe.js has not yet loaded.
          // Make sure to disable form submission until Stripe.js has loaded.
          return;
      }
      setClickSumbit(true);
      const { error } = await stripe.confirmSetup({
          //`Elements` instance that was used to create the Payment Element
          elements,
          confirmParams: {
              return_url: `${url}/memberLoading?butType=4&userCardId=${cardId}`,
              payment_method_data: {
                  billing_details: {
                      name: userName,
                  }
              }
          },
      });
      setClickSumbit(false);
      if (error) {
        // This point will only be reached if there is an immediate error when
        // confirming the payment. Show error to your customer (for example, payment
        // details incomplete)
        setErrorMessage(error.message);
      } else {
        // Your customer will be redirected to your `return_url`. For some payment
        // methods like iDEAL, your customer will be redirected to an intermediate
        // site first to authorize the payment, then redirected to the `return_url`.
      }
  };

  return (
    <form onSubmit={handleSubmit}>
      <PaymentElement onReady={() => { setPayLoading(true); }}/>
      {
        !clickSumbit && (
          <img src={require('../../../assets/imgs/svg/coupons_close.svg').default} alt="close icon" className="pay_close" onClick={closePayPopupHandle} />
        )
      }
      {payLoading ? (
        <StyledButton disabled={clickSumbit ? true : false}>
          Submit
        </StyledButton>
        ) : (
        <LoadText>Loading...</LoadText>
      )}
      {errorMessage && <div>{errorMessage}</div>}
    </form>
  );
};

export default SetupIntent;